import { render, staticRenderFns } from "./FeedView_Jokes.vue?vue&type=template&id=20fd8510&"
import script from "./FeedView_Jokes.vue?vue&type=script&lang=js&"
export * from "./FeedView_Jokes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports